import { inject, Injectable } from '@angular/core';
import { MarketDashboard } from '@clean-code/models';
import { EnumValue, ID } from '@clean-code/models/common';
import { Observable } from 'rxjs';
import { MarketDashboardDataService } from '../infrastructure/dashboard.data.service';

@Injectable()
export class DashboardFacade {
  private service = inject(MarketDashboardDataService);

  public timeFrames$(): Observable<EnumValue[]> {
    return this.service.timeFrames$();
  }

  add$(input: MarketDashboard) {
    return this.service.add$(input);
  }

  update$(input: MarketDashboard) {
    return this.service.update$(input);
  }

  getAll$(): Observable<MarketDashboard[]> {
    return this.service.getAll$();
  }

  getById$(_id: ID) {
    return this.service.getById$(_id);
  }

  getByName$(_name: string) {
    return this.service.getByName$(_name);
  }

  delete$(_id: ID) {
    return this.service.delete$(_id);
  }
}
